export default {
    setFaqs(state,payload){
        state.faqs = payload;
    }
}